// Webpack Imports
import * as bootstrap from 'bootstrap';


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	function setCookie(cname, cvalue, exminutes) {
		let d = new Date();
		let expires;

		// d.setTime(d.getTime())
		// expires = "expires="+d.toUTCString();
		// console.log(expires);

		d.setTime(d.getTime() + (exminutes * 60 * 1000));
		expires = "expires=" + d.toUTCString();
		// console.log(expires);

		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	let lekdenvip_popup = getCookie("lekdenvip_popup");
	if (lekdenvip_popup != "") {
		//if (false) {

	} else {

		if ($("#lekdenvip_popup").length > 0) {

			let img_src = $("#lekdenvip_popup").find('img').data('src');
			$("#lekdenvip_popup").find('img').attr('src', img_src);
			setTimeout(function () {
				$.fancybox.open({
					src: '#lekdenvip_popup',
					type: 'inline',
					animationEffect: 'fade',
					protect: true,
					opts: {
						afterShow: function (instance, current) {
							console.info('done!');
						}
					}
				});
			}, 1000);

			setCookie("lekdenvip_popup", '1', 10);
		}
	}
	$(".lotto_check").on("click", function () {
		let result_head = $("#result_head");
		let lotto_code = $("#lotto_code").val();
		let lotto_number = $("#lotto_number").val();
		let lotto_modal_img = $("#lotto_modal_img");
		let lotto_modal_text = $("#lotto_modal_text");
		var lotto_modal = new bootstrap.Modal(document.getElementById('lotto_modal'))

		result_head.show();

		if (lotto_number == "") {
			$("#result_txt").html = "กรุณากรอกเลขสลาก";
		} else {
			if (lotto_number.length < 6) {
				$("#result_txt").text("กรุณากรอกเลขสลากให้ครบ 6 หลัก");
			} else {
				if (isNaN(lotto_number)) {
					$("#result_txt").text("กรุณากรอกเฉพาะตัวเลข");
				} else {

					result_head.hide();
					$("#result_txt").text();

					$.ajax({
						type: "POST",
						url: site_url+"/wp-admin/admin-ajax.php",
						data: {
							action: 'check_huay_thai',
							lotto_code: lotto_code,
							lotto_number: lotto_number
						},
						success: function (result) {
							result = JSON.parse(result);
							
							if (result.status!='success') {
								result_head.show();
								$("#result_txt").text(result.text);
							} else {

								lotto_modal_img.prop("src",template_url+'/assets/images/lotto/'+result.img);
								lotto_modal_text.text(result.text);
								lotto_modal.show();
							}

						}
					});
				}
			}
		}
	});

	var check_lotto = function () {
		document.getElementById("result_head").style.display = 'block';
		var lotto_code = document.getElementById("lotto_code").value;
		var lotto_number = document.getElementById("lotto_number").value;
		if (lotto_number == "") {
			document.getElementById("result_txt").innerHTML = "กรุณากรอกเลขสลาก";
		} else {
			if (lotto_number.length < 6) {
				document.getElementById("result_txt").innerHTML = "กรุณากรอกเลขสลากให้ครบ 6 หลัก";
			} else {
				if (isNaN(lotto_number)) {
					document.getElementById("result_txt").innerHTML = "กรุณากรอกเฉพาะตัวเลข";
				} else {
					$.ajax({
						type: "POST",
						url: "check_lottory",
						data: {
							lotto_code: lotto_code,
							lotto_number: lotto_number
						},
						success: function (result) {
							console.log(result);
							/*
							if (isNaN(aaa)) {
								if (aaa == "สลากฯ ยังไม่ออก") {
									document.getElementById("result").innerHTML = aaa;
								} else {
									document.getElementById("result").innerHTML = '';
									document.getElementById("result2").innerHTML = 'ยินดีด้วยจ้า คุณ' + aaa;
									$('#good2').trigger('click');
								}
		
							} else {
								document.getElementById("result").innerHTML = '';
								if (aaa == 0) {
									$('#fail').trigger('click');
								} else {
									if (aaa == 1) {
										var img = "https://huaysong.com/img/รางวัลที่1.gif"
									} else if (aaa == 2) {
										var img = "https://huaysong.com/img/รางวัลที่2.gif"
									} else if (aaa == 3) {
										var img = "https://huaysong.com/img/รางวัลที่3.gif"
									} else if (aaa == 4) {
										var img = "https://huaysong.com/img/รางวัลที่4.gif"
									} else if (aaa == 5) {
										var img = "https://huaysong.com/img/รางวัลที่5.gif"
									} else if (aaa == 11) {
										var img = "https://huaysong.com/img/รางวัลข้างเคียง.gif"
									} else if (aaa == 31) {
										var img = "https://huaysong.com/img/รางวัลเลขหน้า3ตัว.gif"
									} else if (aaa == 13) {
										var img = "https://huaysong.com/img/รางวัลเลขท้าย3ตัว.gif"
									} else if (aaa == 12) {
										var img = "https://huaysong.com/img/รางวัลเลขท้าย2ตัว.gif"
									}
		
									document.getElementById("imggood").src = img;
									$('#good').trigger('click');
								}
							}
	*/



						}
					});
				}
			}
		}
	}


})();



function lotto_check(test) {
	console.log(test);
}
